import {
  Directive,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
  OnInit,
  OnDestroy,
  ElementRef,
  Renderer2
} from '@angular/core';
import { TabsetComponent } from './tabset.component';


export class TabDirective implements OnInit, OnDestroy {
  /** tab header text */
   heading: string;
  /** tab id */
   id: string;
  /** if true tab can not be activated */
   disabled: boolean;
  /** if true tab can be removable, additional button will appear */
   removable: boolean;
  /** if set, will be added to the tab's class atribute */
  
  get customClass(): string {
    return this._customClass;
  }

  set customClass(customClass: string) {
    if (this._customClass && this._customClass !== customClass) {
      this.renderer.removeClass(
        this.elementRef.nativeElement,
        this._customClass
      );
    }

    this._customClass = customClass;

    if (this._customClass) {
      this.renderer.addClass(
        this.elementRef.nativeElement,
        this._customClass
      );
    }
  }

  /** tab active state toggle */
  
  
  get active(): boolean {
    return this._active;
  }

  set active(active: boolean) {
    if (this._active === active) {
      return;
    }
    if ((this.disabled && active) || !active) {
      if (this._active && !active) {
        this.deselect.emit(this);
        this._active = active;
      }

      return;
    }

    this._active = active;
    this.select.emit(this);
    this.tabset.tabs.forEach((tab: TabDirective) => {
      if (tab !== this) {
        tab.active = false;
      }
    });
  }

  /** fired when tab became active, $event:Tab equals to selected instance of Tab component */
   select: EventEmitter<TabDirective> = new EventEmitter();
  /** fired when tab became inactive, $event:Tab equals to deselected instance of Tab component */
   deselect: EventEmitter<TabDirective> = new EventEmitter();
  /** fired before tab will be removed, $event:Tab equals to instance of removed tab */
   removed: EventEmitter<TabDirective> = new EventEmitter();

   addClass = true;

  headingRef: TemplateRef<any>;
  tabset: TabsetComponent;
  protected _active: boolean;
  protected _customClass: string;

  constructor(
    tabset: TabsetComponent,
    public elementRef: ElementRef,
    public renderer: Renderer2
  ) {
    this.tabset = tabset;
    this.tabset.addTab(this);
  }

  ngOnInit(): void {
    this.removable = this.removable;
  }

  ngOnDestroy(): void {
    this.tabset.removeTab(this, { reselect: false, emit: false });
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{ selector: 'tab, [tab]' }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TabsetComponent, },
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'heading': [{ type: Input },],
'id': [{ type: Input },],
'disabled': [{ type: Input },],
'removable': [{ type: Input },],
'customClass': [{ type: Input },],
'active': [{ type: HostBinding, args: ['class.active', ] },{ type: Input },],
'select': [{ type: Output },],
'deselect': [{ type: Output },],
'removed': [{ type: Output },],
'addClass': [{ type: HostBinding, args: ['class.tab-pane', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../.tmp/tabs/tab.directive.ts